module.exports = __webpack_public_path__ + "static/preview-gotland-800-0e361fe0c18c746a49abe44e31a1570d.jpg";